<template>
  <font-awesome-icon v-bind="{ ...$props, ...$attrs }"></font-awesome-icon>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faGraduationCap, faCheck, faCheckCircle, faRightToBracket,  // procedure list
  faCaretRight, faCaretLeft, faMagnifyingGlassPlus, faMagnifyingGlassMinus,  // pdf viewer
  faBars, // menu
  faThumbsUp, faThumbsDown, faBookOpen,  // procedure learning
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
library.add(
    faGraduationCap, faCheck, faCheckCircle, faRightToBracket,
    faCaretRight, faCaretLeft, faMagnifyingGlassPlus, faMagnifyingGlassMinus,
    faBars,
    faThumbsUp, faThumbsDown, faBookOpen,
    faTimes
)

export default {
  name: "LATIcon",
  components: {FontAwesomeIcon}
}
</script>

<style scoped>

</style>